import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';

import ListItemIcon from '@material-ui/core/ListItemIcon';
import { withRouter } from 'react-router-dom';
import ReactToPrint from 'react-to-print';


import ShareIcon from '@material-ui/icons/Share';
import PrintIcon from '@material-ui/icons/Print';


import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  WhatsappIcon,
  WhatsappShareButton,
  EmailIcon,
  EmailShareButton,
} from 'react-share';


class SharingBar extends Component {
  state = {
    anchorEl: null,
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;
    const actualUrl = `https://der-waehrungsrechner.de${this.props.location.pathname}`;

    return (
      <Grid container>
        <Grid item xs={6}>

          <ReactToPrint
            trigger={() => (
              <Button
                fullWidth
              >
                <PrintIcon style={{ marginRight: '1rem' }} /> Drucken
              </Button>

            )}
            content={() => this.props.printComponenetRef}
          />


        </Grid>
        <Grid item xs={6}>
          <Button
            aria-owns={anchorEl ? 'fade-menu-share' : null}
            aria-haspopup="true"
            onClick={this.handleClick}
            fullWidth
          >
            <ShareIcon style={{ marginRight: '1rem' }} /> Teilen
          </Button>
          <Menu
            getContentAnchorEl={null}
            id="fade-menu-share"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}

          >


            <MenuItem dense component={FacebookShareButton} url={actualUrl}>
              <ListItemIcon>
                  <FacebookIcon size={22} round />
              </ListItemIcon> <ListItemText>Facebook</ListItemText>
            </MenuItem>

            <MenuItem dense component={WhatsappShareButton} url={actualUrl}>
              <ListItemIcon>
                  <WhatsappIcon size={22} round />
              </ListItemIcon> <ListItemText>WhatsApp</ListItemText>
            </MenuItem>

            <MenuItem dense component={TwitterShareButton} url={actualUrl}>
              <ListItemIcon>
                  <TwitterIcon size={22} round />
              </ListItemIcon> <ListItemText>Twitter</ListItemText>
            </MenuItem>

            <MenuItem dense component={EmailShareButton} url={actualUrl}>
              <ListItemIcon>
                  <EmailIcon size={22} round />
              </ListItemIcon> <ListItemText>E-Mail</ListItemText>
            </MenuItem>

          </Menu>
        </Grid>
      </Grid>
    );
  }
}

SharingBar.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(SharingBar);



// WEBPACK FOOTER //
// ./src/components/calculator/SharingBar.js